export default __webpack_public_path__ + "assets/images/55da9cff871929efea17f7a39606c8e5.png";